import React, { FunctionComponent, useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Select, MenuItem, FormControl, InputLabel, IconButton, Typography, FormControlLabel, Radio, RadioGroup, FormLabel } from "@mui/material";
import { Close } from "@mui/icons-material";
import MenuSaveAPI, { MenuSaveRequest } from "../../../apis/OB/SaveApi/MenuSaveAPI";
import MenuDeleteAPI from "../../../apis/OB/Get/MenuDeleteAPI";
import { showToast } from "../../../helpers/ToastifyHelper";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import SessionStorageService from '../../../services/StorageService';

const iconList = [
  "fa fa-credit-card-alt", "fa fa-desktop", "fa fa-list-alt", 
  "icofont icofont-id-card", "fa fa-pencil-square-o", "fa fa-building-o",
  "icofont icofont-recycle-alt", "icofont icofont-read-book", "icofont icofont-multimedia",
  "icofont icofont-license", "icofont icofont-recycle-alt", "fa fa-bolt",
  "icofont icofont-fire-alt", "fa fa-group", "icofont icofont-users-alt-4",
  "icofont icofont-architecture-alt", "icofont icofont-contact-add", "fa fa-align-justify",
  "icofont icofont-pills", "icofont icofont-ui-clock", "icofont icofont-garbage",
  "icofont icofont-bank-alt", "icofont icofont-lawyer-alt-2", "icofont icofont-list",
  "icon-announcement", "fa fa-turkish-lira", "icofont icofont-file-alt",
  "icofont icofont-group-students", "icon-bookmark-alt", "fa fa-clipboard",
  "icofont icofont-ui-v-card", "icofont icofont-stock-search", "icofont icofont-contact-add",
  "icon-share", "icofont icofont-law-document", "icon-dashboard", "icon-pencil-alt",
  "icofont icofont-ui-contact-list", "icofont icofont-error", "fa fa-tint",
  "icofont icofont-ui-clip-board", "icofont icofont-copy-alt", "icofont icofont-building-alt",
  "fa fa-recycle", "icofont icofont-copy-alt", "icofont icofont-puzzle",
  "icon-trash", "icon-id-badge", "icon-write"
];

const iconPathList = [
  "/online-odeme.svg", "/odemeEkrani.svg", "/odemeBilgileri.svg", "/online-basvurular.svg",
  "/istekSikayetBasvuru.svg", "/emlakVergisiBasvuru.svg", "/cevreTemizlikBasvuru.svg",
  "/ilanReklamBasvuru.svg", "/eglenceVergiBasvuru.svg", "/isyeriRuhsatBasvuru.svg",
  "/katiAtikBasvuru.svg", "/elektrikHavaGaziBasvuru.svg", "/yanginSigortaBasvuru.svg",
  "/sosyalYardimBasvuru.svg", "/evlendirmeOnBasvuru.svg", "/online-basvurular.svg",
  "/basvurularim.svg", "/bilgilendirmeler.svg", "/nobetciEczaneler.svg", "/copToplama.svg",
  "/geriDonusum.svg", "/meclisKararlari.jpg", "/encumenKararlari.jpg",
  "/kayitli-bilgilerim.svg", "/beyanlarBildirimler.svg", "/odemeEmirleri.svg", 
  "/hacizVarakasi.svg", "/bursa-basvur.svg", "/proje-onerileri.svg", "/evrak-takip.svg", 
  "/e-abonelik.svg", "/suAboneVeEndeksBilgilerim.svg", "/yeniAbonelik.svg",
  "/abonelikDevir.svg", "/abonelikIptal.svg", "/endeksBildirim.svg", "/faturaItiraz.svg",
  "/arizaBasvuru.svg", "/kacakSuIhbar.svg", "/onlineSuHizmetBasvurusu.svg", "/vergi-affi.svg",
  "/tarifeler.svg", "/emlakTarifesi.svg", "/cevreTemizlikTarifesi.svg", "/reklamTarifesi.svg",
  "/eglenceVergisiTarifesi.svg", "/katiAtikTarifesi.svg", "/e-bordro.svg", "/anket.svg"
];

const MenuPopUp: FunctionComponent<any> = (props) => {
  const [uyeTipi, setUyeTipi] = useState<number | null>(null);
  const [ikonYolu, setIkonYolu] = useState<string | null>(null);
  const [ikonYolu2, setIkonYolu2] = useState<string | null>(null);
  const [menuAdi, setMenuAdi] = useState<string>("");
  const [sayfaLink, setSayfaLink] = useState<string>("https://");
  const [menuSirasi, setMenuSirasi] = useState<string>("");
  const [requiredInputError, setRequiredInputError] = useState<any[]>([]);
  const [kayitTamamlandiMi, setKayitTamamlandiMi] = useState(false);
  const [isRequiredPopUpVisible, setIsRequiredPopUpVisible] = useState(false);
  const [yayinlanmaBaslangic, setYayinlanmaBaslangic] = useState<any>(dayjs(new Date()));
  const [yayinlanmaBitis, setYayinlanmaBitis] = useState<any>(null);
  const [linkGuncellenebilir, setLinkGuncellenebilir] = useState(true);
  const user = SessionStorageService.getUserInfo();

  useEffect(() => {
    if (props.type === "guncelle") {
      setMenuAdi(props.item.menuAdi);
      setMenuSirasi(props.item.menuSirasi);
      setIkonYolu(props.item.ikonYolu);
      setIkonYolu2(props.item.ikonYolu2);
      setUyeTipi(props.item.uyeTipi);
      setSayfaLink(props.item.sayfaLink);
      setYayinlanmaBaslangic(props.item.yayinlanmaTarihi ? dayjs(props.item.yayinlanmaTarihi) : dayjs(new Date()));
      setYayinlanmaBitis(props.item.yayinlanmaBitisTarihi ? dayjs(props.item.yayinlanmaBitisTarihi) : null);
      
      setLinkGuncellenebilir(props.item.guncellemeIzni !== "H");
    }
  }, [props.item, props.type]);

  const requiredInputControl = () => {
    const errors = [];
    if (menuAdi === "") errors.push("Menü Adı");
    if (ikonYolu === null) errors.push("İkon");
    if (ikonYolu2 === null) errors.push("Ana Menü İkonu");
    if (uyeTipi === null) errors.push("Üye Tipi");
    if (menuSirasi === "") errors.push("Menü Sırası");
    if (!yayinlanmaBaslangic) errors.push("Yayınlanma Başlangıç Tarihi");

    return errors;
  };

  const handleSave = () => {
    const errors = requiredInputControl();
    if (errors.length > 0) {
      setRequiredInputError(errors);
      setIsRequiredPopUpVisible(true);
      return;
    }

    let request = new MenuSaveRequest(
      menuAdi,
      parseInt(menuSirasi),
    
      ikonYolu!,
      ikonYolu2!,
      uyeTipi!,
      linkGuncellenebilir?"E":"H",
      1,
      user.sqId.toString(),
      new Date(),
      user.sqId.toString(),
      !linkGuncellenebilir ? props.item.sayfaLink : (sayfaLink === "https://" ? undefined : sayfaLink),
      props.type === "guncelle" ? props.sqId : undefined,
      props.type === "guncelle" ? props.item.parentId : props.sqId !== null ? props.sqId : undefined,
      new Date(),
      yayinlanmaBaslangic.toDate(),
      yayinlanmaBitis ? yayinlanmaBitis.toDate() : undefined
    );

    MenuSaveAPI.saveMenuSaveSave(request)
      .then((response) => {
        if (response.data.sonuc === 0) {
          props.kayitBasariliMi(!props.basariliMi);
          showToast(response.data.sonucAciklama, "success");

          props.close(false);
        } else {
          showToast(response.data.sonucAciklama, "error");
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setKayitTamamlandiMi(true);
      });
  };

  const handleDelete = (sqId: number) => {
    MenuDeleteAPI.getMenuDelete(sqId)
      .then((response) => {
        if (response.data.sonuc === 0) {
          props.kayitBasariliMi(!props.basariliMi);
          props.close(false);
        } else {
          showToast(response.data.sonucAciklama, "error");
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setKayitTamamlandiMi(true);
      });
  };

  const requiredInputErrorScreenViewText = () => {
    let text = "Lütfen Zorunlu Alanları Doldurunuz: ";
    requiredInputError.forEach((element, index) => {
      text += element + (index < requiredInputError.length - 1 ? ", " : "!");
    });
    return text;
  };

  return (
    <>
      <Dialog open={true} onClose={() => props.close(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {props.type === "ekle" ? "Menü Ekle" : props.type === "guncelle" ? "Menü Güncelle" : "Menü Sil"}
          <IconButton
            aria-label="close"
            onClick={() => props.close(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {(props.type === "ekle" || props.type === "guncelle") && (
            <>
              <TextField
                margin="dense"
                label="Menü Adı"
                fullWidth
                value={menuAdi}
                onChange={(e) => setMenuAdi(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Menü Sırası"
                type="number"
                fullWidth
                value={menuSirasi}
                onChange={(e) => setMenuSirasi(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Menü Linki"
                fullWidth
                value={sayfaLink}
                onChange={(e) => setSayfaLink(e.target.value)}
                disabled={props.type === "guncelle" && !linkGuncellenebilir}
                helperText={props.type === "guncelle" && !linkGuncellenebilir ? "Bu menünün linki güncellenemez" : ""}
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>İkon Seç</InputLabel>
                <Select
                  value={ikonYolu2}
                  onChange={(e) => setIkonYolu2(e.target.value)}
                >
                  {iconList.map((icon) => (
                    <MenuItem key={icon} value={icon}>
                      <i className={icon}></i>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Ana Menü İkonu Seç</InputLabel>
                <Select
                  value={ikonYolu}
                  onChange={(e) => setIkonYolu(e.target.value)}
                >
                  {iconPathList.map((path) => (
                    <MenuItem key={path} value={path}>
                      <img src={path} alt="" width={50} height={50} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl component="fieldset" margin="normal">
                <FormLabel component="legend">Menü'yü Kimler Görebilir?</FormLabel>
                <RadioGroup
                  row
                  value={uyeTipi}
                  onChange={(e) => setUyeTipi(parseInt(e.target.value))}
                >
                  <FormControlLabel value={1} control={<Radio />} label="Admin" />
                  <FormControlLabel value={2} control={<Radio />} label="Herkes" />
                  <FormControlLabel value={3} control={<Radio />} label="Personel" />
                  
                </RadioGroup>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Yayınlanma Başlangıç Tarihi *"
                  value={yayinlanmaBaslangic}
                  onChange={(newValue) => setYayinlanmaBaslangic(newValue)}
                  disabled={props.type === "guncelle" && user && user.isSuperAdmin === false }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: "normal",
                    }
                  }}
                />
                <DatePicker
                  label="Yayınlanma Bitiş Tarihi"
                  value={yayinlanmaBitis}
                  onChange={(newValue) => setYayinlanmaBitis(newValue)}
                  disabled={props.type === "guncelle" && user && user.isSuperAdmin === false }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: "normal"
                    }
                  }}
                />
              </LocalizationProvider>
              {isRequiredPopUpVisible && (
                <Typography color="error">{requiredInputErrorScreenViewText()}</Typography>
              )}
            </>
          )}
          {props.type === "sil" && (
            <Typography>Menüyü silmek istediğinize emin misiniz?</Typography>
          )}
        </DialogContent>
        <DialogActions>
          {props.type === "ekle" && (
            <Button onClick={handleSave} color="primary" variant="contained">Kaydet</Button>
          )}
          {props.type === "guncelle" && (
            <Button onClick={handleSave} color="primary" variant="contained">Güncelle</Button>
          )}
          {props.type === "sil" && (
            <Button onClick={() => handleDelete(props.sqId)} color="secondary" variant="contained">Sil</Button>
          )}
          <Button onClick={() => props.close(false)} color="secondary">İptal</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MenuPopUp;
